import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from 'src/app/base/base.component';
import { Config } from 'src/infrastructure/config';
import { ImageCollection } from 'src/models/DTO/image/imageCollection';
import { UserDTO } from 'src/models/DTO/user/user';
import { UserService } from 'src/services/core/user/user.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent extends BaseComponent implements OnInit {


  private _loggedUser?: UserDTO;
  private _image?: ImageCollection

  
  constructor(
    private userService: UserService,
    private userStateService: LoggedUserService,
    private imagesService: ImagesService,
    private router: Router,
    private modalService: NgbModal
  ) { 
    super();
    this.pageTitle = 'account';
    this.userStateService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
      if (user && Object.keys(user).length) {
        this.imagesService.getImagesForProduct('USER', this._loggedUser.data.uuid, 'logo').subscribe(images => {
          this._image = images;
        })
      }
    })
   }

  ngOnInit(): void {
  }

  get isUserLogged() {
    return this.userService.isUserLogged();
  }

  get loggedUser() {
    return this._loggedUser;
  }

  get image() {
    return this._image?.data[0]?.original.url || '/assets/images/account/avatar.svg';
  }

  get config() {
    return Config;
  }

  public goToLogin() {
    this.router.navigate(['login']);
  }

  onAccountTap(loginModal: any) {
    if (this.isUserLogged) {
      this.router.navigate(['user/info']);
    }
    else {
      this.modalService.open(loginModal, {  size: 'sm', windowClass: 'loginModal' })
    }
  }

  onSettingsTap(loginModal: any) {
    if (this.isUserLogged) {
      this.router.navigate(['user/settings']);
    }
    else {
      this.modalService.open(loginModal, { size: 'sm',  windowClass: 'loginModal' })
    }
  }

  onVouchersClick(loginModal: any) {
    if (this.isUserLogged) {
      this.router.navigate(['user/vouchers']);
    }
    else {
      this.modalService.open(loginModal, { size: 'sm',  windowClass: 'loginModal' })
    }
  }

  onDocumentsTap() {
    this.router.navigate(['user/documents']);
  }

  onContactsTap() {
    this.router.navigate(['user/support']);
  }

  invite() {
    if (this.isUserLogged) {
      this.router.navigate(['invite']);
    }
    else {
      alert("Not logged")
    }
  }

  oprenUrl(url: string) {
    window.open(url, '_blank');
  }

  logOut(modal: any) {
    this.modalService.open(modal, { centered: true, size: 'sm' })
  }

  logOutFromApp(modal: any) {
    modal.close();
    this.userService.logOut();

  }

  registration(currentModal: any) {
    currentModal.close();
    this.router.navigate(['registration']);
  }

  loginNavigation(currentModal: any) {
    currentModal.close();
    this.router.navigate(['login']);
  }
}
